export const DEMARRAGE_KEY = 'demarrage';
